import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

function FoodEditModal({ isOpen, onClose, food, onSave }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    culture: 'ETHIOPIAN',
    safetyStatus: 'SAFE',
    reason: '',
    alternative: '',
    notes: ''
  });

  useEffect(() => {
    if (food) {
      setFormData({
        name: food.name || '',
        culture: food.culture || 'ETHIOPIAN',
        safetyStatus: food.safetyStatus || 'SAFE',
        reason: food.reason || '',
        alternative: food.alternative || '',
        notes: food.notes || ''
      });
    }
  }, [food]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={food ? `✏️ ${t('food.edit.titleEdit', { name: food.name })}` : `➕ ${t('food.edit.titleAdd')}`}>
      <form className="modal-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>🍎 {t('food.edit.foodName')}</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            required
            placeholder={t('food.edit.foodNamePlaceholder')}
          />
        </div>
        
        <div className="form-group">
          <label>🌍 {t('food.edit.culture')}</label>
          <select
            value={formData.culture}
            onChange={(e) => setFormData({...formData, culture: e.target.value})}
            required
          >
            <option value="ETHIOPIAN">🇪🇹 {t('food.edit.cultureEthiopian')}</option>
            <option value="ERITREAN">🇪🇷 {t('food.edit.cultureEritrean')}</option>
            <option value="SPANISH">🇪🇸 {t('food.edit.cultureSpanish')}</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>🛡️ {t('food.edit.safetyStatus')}</label>
          <select
            value={formData.safetyStatus}
            onChange={(e) => setFormData({...formData, safetyStatus: e.target.value})}
            required
          >
            <option value="SAFE">✅ {t('food.edit.safe')}</option>
            <option value="UNSAFE">❌ {t('food.edit.unsafe')}</option>
            <option value="CAUTION">⚠️ {t('food.edit.caution')}</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>📝 {t('food.edit.reason')}</label>
          <textarea
            value={formData.reason}
            onChange={(e) => setFormData({...formData, reason: e.target.value})}
            rows="3"
            placeholder={t('food.edit.reasonPlaceholder')}
          />
        </div>
        
        <div className="form-group">
          <label>🔄 {t('food.edit.alternative')}</label>
          <input
            type="text"
            value={formData.alternative}
            onChange={(e) => setFormData({...formData, alternative: e.target.value})}
            placeholder={t('food.edit.alternativePlaceholder')}
          />
        </div>
        
        <div className="form-group">
          <label>📋 {t('food.edit.notes')}</label>
          <textarea
            value={formData.notes}
            onChange={(e) => setFormData({...formData, notes: e.target.value})}
            rows="2"
            placeholder={t('food.edit.notesPlaceholder')}
          />
        </div>
        
        <div className="modal-footer">
          <button type="button" className="btn-secondary" onClick={onClose}>
            {t('food.edit.cancel')}
          </button>
          <button type="submit" className="btn-primary">
            💾 {food ? t('food.edit.update') : t('food.edit.create')}
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default FoodEditModal;
















